module.exports = __webpack_public_path__ + "img/edit_icon.1ad6ae76.svg";